function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GET_GOALMEMBERLISTITEMSBYMEMBERUSERIDANDMEMBERSTATES_REQUEST = "GET_GOALMEMBERLISTITEMSBYMEMBERUSERIDANDMEMBERSTATES_REQUEST";
export var GET_GOALMEMBERLISTITEMSBYMEMBERUSERIDANDMEMBERSTATES_SUCCESS = "GET_GOALMEMBERLISTITEMSBYMEMBERUSERIDANDMEMBERSTATES_SUCCESS";
export var GET_GOALMEMBERLISTITEMSBYMEMBERUSERIDANDMEMBERSTATES_FAILURE = "GET_GOALMEMBERLISTITEMSBYMEMBERUSERIDANDMEMBERSTATES_FAILURE";
export var RESET_GET_GOALMEMBERLISTITEMSBYMEMBERUSERIDANDMEMBERSTATES = "RESET_GET_GOALMEMBERLISTITEMSBYMEMBERUSERIDANDMEMBERSTATES";

// Fetches member cards for a particular member state and user from Front API.
// Relies on the custom API middleware defined in ../middleware/api.js.
export var fetchGoalMemberListItemsByMemberUserIdAndMemberStates = function fetchGoalMemberListItemsByMemberUserIdAndMemberStates(memberUserId, memberStates, timeZoneName, authUserId, maxId, sinceId, count) {
  var queryString = urlSearchParams({
    memberUserId: memberUserId,
    memberStates: memberStates,
    timeZoneName: timeZoneName,
    authUserId: authUserId,
    maxId: maxId,
    sinceId: sinceId,
    count: count
  });
  return _defineProperty({
    memberUserId: memberUserId,
    memberStates: memberStates,
    timeZoneName: timeZoneName,
    authUserId: authUserId,
    maxId: maxId,
    sinceId: sinceId,
    count: count
  }, CALL_API, {
    types: [GET_GOALMEMBERLISTITEMSBYMEMBERUSERIDANDMEMBERSTATES_REQUEST, GET_GOALMEMBERLISTITEMSBYMEMBERUSERIDANDMEMBERSTATES_SUCCESS, GET_GOALMEMBERLISTITEMSBYMEMBERUSERIDANDMEMBERSTATES_FAILURE],
    endpoint: "goalMemberListItems/search/findByMemberUserIdAndMemberStateIn".concat(queryString),
    init: {
      credentials: "same-origin"
    }
  });
};